import axios from './index'
const origin = "/co/store/"

/**
 * 获取总店/门店
 * @param {Guid} param = Guid.Empty
 */
const getStore = (param = "00000000-0000-0000-0000-000000000000") => {
    return new Promise(resolve => {
        axios.get(origin + "GetStore?companyId=" + param).then(res => {
            resolve(res)
        })
    })
}
const loadStoreList = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/loadStoreList', param).then(res => resolve(res));
    });
}
const lookStore = (id) => {
    return new Promise((resolve) => {
        axios.post(origin + '/lookStore', id).then(res => resolve(res));
    });
}
const addStore = (param) => {
    return new Promise((resolve) => {
            axios.post(origin + '/addStore', param).then(res => resolve(res));
        }

    )
}
const updateStore = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/updateStore', param).then(res => resolve(res));
    })
}
const deleteStore = param => {
    return new Promise((resolve) => {
            axios.post(origin + '/deleteStore', param).then(res => resolve(res));
        }

    )
}
const disableStore = param => {
    return new Promise((resolve) => {
            axios.post(origin + '/disableStore', param).then(res => resolve(res));
        }

    )
}

const enableStore = param => {
    return new Promise((resolve) => {
            axios.post(origin + '/enableStore', param).then(res => resolve(res));
        }

    )
}

const getRoles = () => {
    return new Promise((resolve) => {
        axios.post(origin + '/getStoreRoles').then(res => {
            resolve(res)
        })
    });
}

const addStoreAccount = (param) => {
    return new Promise((resolve) => {
            axios.post(origin + '/addStoreAccount', param).then(res => resolve(res));
        }
    )
}


const getPointType = (param) => {
    return new Promise((resolve) => {
            axios.post(origin + '/getPointType', param).then(res => resolve(res));
        }
    )
}

const lookStoreAccount = (param) => {
    return new Promise((resolve) => {
            axios.post(origin + '/lookStoreAccount', param).then(res => resolve(res));
        }
    )
}

const updateStoreAccount = (param) => {
    return new Promise((resolve) => {
            axios.post(origin + '/updateStoreAccount', param).then(res => resolve(res));
        }
    )
}

const changeStoreAccount = (param) => {
    return new Promise((resolve) => {
            axios.post(origin + '/changeStoreAccount', param).then(res => resolve(res));
        }
    )
}

const lookStoreByCompany = (param) => {
    return new Promise((resolve) => {
            axios.post(origin + '/LookStoreByCompany', param).then(res => resolve(res));
        }
    )
}


export default {
    getStore,
    loadStoreList,
    lookStore,
    addStore,
    updateStore,
    enableStore,
    disableStore,
    deleteStore,
    getRoles,
    addStoreAccount,
    getPointType,
    lookStoreAccount,
    updateStoreAccount,
    changeStoreAccount,
    lookStoreByCompany
}